import { createContext } from 'react';

/**
 * This context is used to set the data-placement GA4 attribute.
 */
export const GA4DataPlacement = createContext(null);